import { Skeleton, SkeletonCard } from '@repo/ui';

export function ReportsPageSkeleton() {
  return (
    <div className="space-y-6">
      {/* Page Header Skeleton */}
      <div className="flex items-center justify-between mb-2">
        <div>
          <Skeleton variant="text" width="150px" height="2.25rem" className="mb-2" />
          <Skeleton variant="text" width="500px" height="1rem" />
        </div>
      </div>

      {/* Report Cards Skeleton */}
      <div className="space-y-8">
        {/* Category Header */}
        <div>
          <Skeleton variant="text" width="200px" height="1.5rem" className="mb-4" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        </div>
      </div>
    </div>
  );
}

